import React from 'react';

import NextImage from 'next/image';

import { Container } from '../../../../components/Container/Container';
import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import engage from '../../assets/engage.png';

export const AdvertiseEngageSection = () => {
  return (
    <section
      className="bg-lake-fog col-start-1 row-start-2 grid grid-cols-1"
      data-testid="AdvertiseEngageSection"
    >
      <Container className="my-md col-start-1 row-start-1 grid grid-cols-1 flex-col md:grid-cols-12 md:flex-row md:justify-around">
        <div className="relative col-span-full justify-end md:col-span-6">
          <NextImage
            alt="Advertise engage image"
            src={engage}
            className="size-full object-cover sm:object-contain"
          />
        </div>

        <div className="col-span-full mb-4 md:col-span-6 md:mb-0">
          <Heading variant="xl" className="my-2 md:mt-36">
            Why advertise at Fishbrain
          </Heading>

          <Text variant="md">
            Experience the ultimate outdoor advertising advantage through the Fishbrain app, where
            we offer you exclusive access to a highly receptive audience immersed in the world of
            fishing and the great outdoors.
          </Text>
        </div>
      </Container>
    </section>
  );
};
